import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';
import { dateFormat } from '~utils/dateTime';

interface TicketTimeColumnProps {
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function TicketTimeColumn({ sx, ticket }: TicketTimeColumnProps) {
  const ticketDate = ticket?.serviceDate || ticket?.ocrServiceDate || ticket?.createdAt;
  const ticketTime = ticketDate ? dateFormat(ticketDate, 'h:mm A') : '-';
  const ticketDay = ticketDate ? dateFormat(ticketDate, 'MMM D, YYYY') : '-';

  return (
    <Box sx={sx}>
      <OverflowAwareText>{ticketTime}</OverflowAwareText>
      <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
        {ticketDay}
      </OverflowAwareText>
    </Box>
  );
}
